import { useRequest } from '../api/hooks';
import { GMTInfo } from './common';

export const PointEndpoint = `/point`;

// 0: 不限制; 1: 按固定值限制; 2: 按比例限制
export const Pay_Consume_Limit_Types = {
  NO_LIMIT: 0,
  FIXED: 1,
  RATIO: 2,
};

export interface Point {
  num: number;
  comment: string;
  addTime: string;
  type: number;
  typeDesc: string;
}

export interface PointRules extends GMTInfo {
  id: number;
  checkinIncreaseOn: number;
  checkinIncreaseNum: number;
  forwardIncreaseOn: number;
  forwardIncreaseNum: number;
  forwardIncreaseUserDailyLimit: number;
  forwardIncreaseUserTotalLimit: number;
  exchangeRules: {
    key: number;
    value: string;
  }[];
  exchangeRulesExtra: string;

  payConsumeOn: boolean;
  payConsumeUnit: number;
  payConsumeAmount: number;
  payConsumeLimitType: number;
  payConsumeLimitNum: number;
}

export const requestPointRules = () =>
  useRequest<PointRules>(
    {
      method: 'get',
      url: `${PointEndpoint}/rules`,
    },
    { manual: true }
  );
